import React from 'react';
import { SDS_SIZE_BORDER_MEDIUM, SDS_SIZE_BORDER_SMALL, SDS_SIZE_BORDER_LARGE } from '@s-group/design-system-tokens/web/tokens/size.es6.js';
import '../CheckableBase/CheckableBase.js';
import { indicatorSize } from '../CheckableBase/constants.js';
import { pxValue } from '../common/util.js';
import { useMediaQuery } from '../common/hooks.js';

const Indicator = ({ sizing, ...rest }) => {
    // Border circle radius defines the visible outer edge of the indicator in
    // the default (unfocused) state.
    const borderCircleRadius = indicatorSize[sizing] / 2;
    const borderWidth = useMediaQuery('(min-resolution: 150dpi)')
        ? pxValue(SDS_SIZE_BORDER_MEDIUM)
        : pxValue(SDS_SIZE_BORDER_SMALL);
    // Focus outline circle radius is always 2 CSS pixels larger than
    // the border circle radius.
    const focusOutlineWidth = pxValue(SDS_SIZE_BORDER_LARGE);
    const focusCircleRadius = borderCircleRadius + focusOutlineWidth;
    // Background circle doesn't scale proportionaly, it is border width
    // smaller than the border circle.
    const backgroundCircleRadius = borderCircleRadius - borderWidth;
    // View box dimensions are the same as the diameter of
    // the focus outline circle
    const viewBoxDimension = 2 * focusCircleRadius;
    const center = viewBoxDimension / 2;
    // Toggle circle defines the selection toggle indicator in the selected
    // state. Its dimension should be an even number to ensure pixel perfect
    // rendering on non-retina displays.
    const toggleCircleRadius = (borderCircleRadius - (borderCircleRadius % 2)) / 2;
    // Note SVG rendering order: Last circle element is on top.
    return (React.createElement("svg", { ...rest, height: viewBoxDimension, viewBox: `0 0 ${viewBoxDimension} ${viewBoxDimension}`, width: viewBoxDimension, xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("circle", { className: "focus", cx: center, cy: center, r: focusCircleRadius }),
        React.createElement("circle", { className: "border", cx: center, cy: center, r: borderCircleRadius }),
        React.createElement("circle", { className: "background", cx: center, cy: center, r: backgroundCircleRadius }),
        React.createElement("circle", { className: "toggle", cx: center, cy: center, r: toggleCircleRadius })));
};

export { Indicator };
//# sourceMappingURL=RadioButtonIndicator.js.map
